import {
  LOGIN_ADMIN_USER,
  LOGIN_ADMIN_USER_SUCCESS,
  LOGOUT_ADMIN_USER,
  LOGOUT_ADMIN_USER_SUCCESS,
  API_ERROR,
  GET_ADMIN_USER_CURRENT_USER,
  GET_ADMIN_USER_CURRENT_USER_SUCCESS,
  GET_ADMIN_USER_CURRENT_USER_ERROR,
  UPDATE_ADMIN_USER_CURRENT_USER,
  UPDATE_ADMIN_USER_CURRENT_USER_SUCCESS,
  UPDATE_ADMIN_USER_CURRENT_USER_ERROR,
  POST_ADMIN_INTERNAL_USER_LOGIN,
  POST_ADMIN_INTERNAL_USER_LOGIN_SUCCESS,
  POST_ADMIN_INTERNAL_USER_LOGIN_ERROR
} from "./actionTypes"

export const loginAdminUser = (user, history) => {
  return {
    type: LOGIN_ADMIN_USER,
    payload: { user, history },
  }
}

export const loginAdminUserSuccess = user => {
  return {
    type: LOGIN_ADMIN_USER_SUCCESS,
    payload: user,
  }
}

export const logoutAdminUser = history => {
  return {
    type: LOGOUT_ADMIN_USER,
    payload: { history },
  }
}

export const logoutAdminUserSuccess = () => {
  return {
    type: LOGOUT_ADMIN_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const getAdminUserCurrentUser = (history) => {
  return {
    type: GET_ADMIN_USER_CURRENT_USER,
    payload: { history }
  }
}

export const getAdminUserCurrentUserSuccess = user => {
  return {
    type: GET_ADMIN_USER_CURRENT_USER_SUCCESS,
    payload: user
  }
}

export const getAdminUserCurrentUserError = error => {
  return {
    type: GET_ADMIN_USER_CURRENT_USER_ERROR,
    payload: error
  }
}

export const updateAdminUserCurrentUser = user => {
  return {
    type: UPDATE_ADMIN_USER_CURRENT_USER,
    payload: user
  }
}

export const updateAdminUserCurrentUserSuccess = user => {
  return {
    type: UPDATE_ADMIN_USER_CURRENT_USER_SUCCESS,
    payload: user
  }
}

export const updateAdminUserCurrentUserError = error => {
  return {
    type: UPDATE_ADMIN_USER_CURRENT_USER_ERROR,
    payload: error
  }
}

export const postAdminInternalUserLogin = (admin_user, history) => {
  return {
    type: POST_ADMIN_INTERNAL_USER_LOGIN,
    payload: {admin_user, history}
  }
}

export const postAdminInternalUserLoginSuccess = user_login => {
  return {
    type: POST_ADMIN_INTERNAL_USER_LOGIN_SUCCESS,
    payload: user_login,
  }
}

export const postAdminInternalUserLoginError = error => {
  return {
    type: POST_ADMIN_INTERNAL_USER_LOGIN_ERROR,
    payload: error,
  }
}